// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { auth, signInWithEmailAndPassword } from '../firebase';
// import { Container, TextField, Button, Typography, Box } from '@mui/material';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       navigate('/manage-items');
//     } catch (error) {
//       console.error('Error logging in: ', error);
//       alert('Login failed: ' + error.message); // Display error to user
//     }
//   };

//   return (
//     <Container>
//       <Box sx={{ textAlign: 'center', marginBottom: '20px' }}>
//         <Typography variant="h2">Login</Typography>
//       </Box>
//       <form onSubmit={handleLogin}>
//         <TextField
//           label="Email"
//           fullWidth
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           margin="normal"
//         />
//         <TextField
//           label="Password"
//           type="password"
//           fullWidth
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           margin="normal"
//         />
//         <Button type="submit" variant="contained" color="primary">
//           Login
//         </Button>
//       </form>
//     </Container>
//   );
// };

// export default Login;





import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate('/manage-items');
    } catch {
      setError('Failed to log in');
    }
  };

  return (
    <Container>
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">Log in</Typography>
        {error && <Typography color="error">{error}</Typography>}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Email Address"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>Log In</Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
